import React from 'react';
import styles from './planTimeline.module.css';

interface PlanTimelineProps {
  startDate: string;
  endDate: string;
  phoneNumber?: string;
}

const PlanTimeline: React.FC<PlanTimelineProps> = ({
  startDate,
  endDate,
  phoneNumber,
}) => {
  // Format date from DD/MM/YYYY to display format
  const formatDate = (dateStr: string): string => {
    if (!dateStr) return '';
    const parts = dateStr.split('/');
    if (parts.length === 3) {
      return `${parts[0]}/${parts[1]}/${parts[2]}`;
    }
    return dateStr;
  };

  return (
    <div className={styles.timelineContainer}>
      <div className={styles.timelineContent}>
        <div className={styles.timelineLine}>
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="52" viewBox="0 0 7 52" fill="none">
            <line x1="3.5" y1="9" x2="3.5" y2="43" stroke="url(#paint0_linear_533_7578)" strokeDasharray="2.21 2.21"/>
            <circle cx="3.5" cy="9.5" r="3.5" fill="white"/>
            <circle cx="3.5" cy="42.5" r="3.5" fill="#FF4444"/>
            <defs>
              <linearGradient id="paint0_linear_533_7578" x1="3" y1="9" x2="2.93458" y2="43.0008" gradientUnits="userSpaceOnUse">
                <stop stopColor="white"/>
                <stop offset="1" stopColor="#FF4444"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className={styles.timelineItems}>
          <div className={styles.timelineItem}>
            <div className={styles.timelineText}>
              <span className={styles.timelineLabel}>Start date</span>
              <span className={styles.timelineValue}>{formatDate(startDate)}</span>
            </div>
          </div>
          <div className={styles.timelineItem}>
            <div className={styles.timelineText}>
              <span className={styles.timelineLabel}>End date</span>
              <span className={styles.timelineValue}>{formatDate(endDate)}</span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.divider}></div>
      {phoneNumber && (
        <div className={styles.activationText}>
          Subscription will be activated on {phoneNumber}
        </div>
      )}
    </div>
  );
};

export default PlanTimeline;

